import React, { useState } from "react";

export function scrollToSection(id: string) {
  const element = document.getElementById(id);
  if (element) {
    element.scrollIntoView({ behavior: "smooth" });
  }
}

function Navbar() {
  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  return (
    <nav className="bg-gray-1 text-white top-0 w-full z-10 ">
      <div className="max-w-7xl mx-auto px-2 sm:px-6 lg:px-8">
        <div className="relative flex items-center justify-between h-12 sm:h-18 xl:h-14">
          <div className="absolute inset-y-0 right-0 flex items-center sm:hidden">
            <button
              onClick={toggleMenu}
              className="inline-flex items-center justify-center p-2 mr-2 rounded-md
               text-white hover:text-white focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white"
              aria-expanded={isOpen}
            >
              <span className="sr-only">Open main menu</span>
              <svg
                className="block h-5 w-5"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                aria-hidden="true"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M4 6h16M4 12h16M4 18h16"
                />
              </svg>
            </button>
          </div>

          {/* Desktop Menu */}
          <div className="hidden sm:flex sm:ml-auto sm:mr-auto text-[16px] ">
            <div className="flex space-x-6">
              <a
                href="#experience"
                onClick={() => scrollToSection("experience")}
                className="text-gray-300 hover:text-white px-3 py-2 rounded-md"
              >
                Experience
              </a>
              <a
                href="#teaching"
                onClick={() => scrollToSection("teaching")}
                className="text-gray-300 hover:text-white px-3 py-2 rounded-md"
              >
                Teaching
              </a>
              <a
                href="#education"
                onClick={() => scrollToSection("education")}
                className="text-gray-300 hover:text-white px-3 py-2 rounded-md"
              >
                Education
              </a>
              <a
                href="#projects"
                onClick={() => scrollToSection("projects")}
                className="text-gray-300 hover:text-white px-3 py-2 rounded-md"
              >
                Projects
              </a>
              <a
                href="#awards"
                onClick={() => scrollToSection("awards")}
                className="text-gray-300 hover:text-white px-3 py-2 rounded-md"
              >
                Competitions
              </a>
              <a
                href="#blog"
                onClick={() => scrollToSection("blog")}
                className="text-gray-300 hover:text-white px-3 py-2 rounded-md"
              >
                Writing
              </a>
              <a
                href="#connect"
                onClick={() => scrollToSection("connect")}
                className="text-gray-300 hover:text-white px-3 py-2 rounded-md"
              >
                Connect
              </a>
            </div>
          </div>
        </div>
        {/* Mobile Menu */}
        <div
          className={`${isOpen ? "block" : "hidden"} sm:hidden  text-center`}
        >
          <div className="absolute font-normal top-12 text-sm right-4 mt-1 py-2 w-40 bg-black rounded-lg shadow-lg pl-3 text-left">
            <a
              href="#experience"
              onClick={() => scrollToSection("experience")}
              className="block px-4 py-3 hover:text-white"
            >
              Experience
            </a>
            <a
              href="#teaching"
              onClick={() => scrollToSection("teaching")}
              className="block px-4 py-3 hover:text-white"
            >
              Teaching
            </a>
            <a
              href="#education"
              onClick={() => scrollToSection("education")}
              className="block px-4 py-3 hover:text-white"
            >
              Education
            </a>
            <a
              href="#projects"
              onClick={() => scrollToSection("projects")}
              className="block px-4 py-3 hover:text-white"
            >
              Projects
            </a>
            <a
              href="#awards"
              onClick={() => scrollToSection("awards")}
              className="block px-4 py-3  hover:text-white"
            >
              Competitions
            </a>
            <a
              href="#blog"
              onClick={() => scrollToSection("blog")}
              className="block px-4 py-3 hover:text-white"
            >
              Writing
            </a>
            <a
              href="#connect"
              onClick={() => scrollToSection("connect")}
              className="block px-4 py-3  hover:text-white"
            >
              Connect
            </a>
          </div>
        </div>
      </div>
    </nav>
  );
}

export default Navbar;
